<template>
  <div :class="$style.container" v-if="dataCollectionActivityLogs">
    <div :class="$style.titleSection">
      <div :class="$style.title">DATA HISTORY</div>
    </div>

    <div :class="$style.contentSection">
      <template v-if="histories.length > 0">
        <p-list-item
          v-for="(history, index) in histories"
          :key="`activity${index}`"
          :title="`${history.datetime}`"
        >
          <p>
            <b>{{ history.email }}</b>
            {{ history.description }}
            <router-link
              :class="$style.descriptionLinkStyle"
              :to="`/audits/` + history.audit.id + `#dashboard`"
              >{{ getFormattedTitle(history.audit.name) }}</router-link
            >
            in
            <router-link
              :class="$style.descriptionLinkStyle"
              :to="'/projects/' + history.audit.project.id + ''"
              >{{ getFormattedTitle(history.audit.project.title) }}</router-link
            >
          </p>
        </p-list-item>
      </template>
      <div :class="$style.noDataState" v-else>No data history found</div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';
import dayjs from 'dayjs';
import * as relativeTime from 'dayjs/plugin/relativeTime';
import { DATE_FORMAT } from '@/utils/date.util';
import { useUserEmail } from '@/utils/user.util';

// @ts-ignore
dayjs.extend(relativeTime);

@Component({
  components: {},
})
export default class DashboardDataHistory extends Vue {
  @Action('projects/getDataCollectionActivityLogs')
  public getDataCollectionActivityLogs!: () => void;

  @State((state) => state.projects.dataCollectionActivityLogs)
  public dataCollectionActivityLogs!: any;

  public async mounted() {
    await this.getDataCollectionActivityLogs();
  }

  get userEmail(): string | undefined {
    return useUserEmail.call(this);
  }

  public getFormattedTitle(title: string) {
    if (title.length > 45) {
      return title.substring(0, 45) + '...';
    } else {
      return title;
    }
  }

  get histories() {
    const userEmail = this.userEmail;
    if (Array.isArray(this.dataCollectionActivityLogs)) {
      return this.dataCollectionActivityLogs.slice(0, 10).map((log) => {
        const today = dayjs().format(DATE_FORMAT);
        const yesterday = dayjs().add(-1, 'day').format(DATE_FORMAT);
        const dataUpdatedAt = dayjs(new Date(log.recordedStartDateTime)).format(
          DATE_FORMAT,
        );
        const total: number = log.recordValueTotal || 0;
        let dateToDisplay;
        if (dataUpdatedAt === today) {
          dateToDisplay = 'Today';
        } else if (dataUpdatedAt === yesterday) {
          dateToDisplay = 'Yesterday';
        } else {
          dateToDisplay = dataUpdatedAt;
        }

        return {
          // @ts-ignore
          datetime: dateToDisplay,
          email: log.user.email === userEmail ? 'You' : log.user.email,
          audit: log.audit,
          description: `added ${total} responses to`,
        };
      });
    }
    return [];
  }
}
</script>

<style lang="scss" module>
.container {
  margin-bottom: 5rem;

  .titleSection {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    .title {
      font-weight: bold;
      text-transform: uppercase;
      padding: 8px 0;
    }

    .button {
      border: none;
      background: transparent;
      color: $primary;
    }
  }

  .contentSection {
    box-shadow: 0 1px 2px $grey-border, 0 1px 2px $grey-border;
    border: 0.5px solid $grey-border;
    overflow: hidden;
    border-radius: 6px;
    background: white;
  }

  .noDataState {
    padding: 1rem;
    font-size: 18px;
    font-weight: bold;
    color: #9f9f9f;
    text-align: center;
    height: 155px;
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
  .descriptionLinkStyle {
    font-weight: bold;
    color: #4a4a4a;
  }
  .descriptionLinkStyle:hover {
    text-decoration: underline;
  }
}
</style>
